<template>
  <div class="row">
    <div class="col-md-12">
      <div class="mb-3">
        <label for="server" class="col-form-label">Service</label>
        <select
          class="form-select"
          id="server"
          v-model="form.service_id"
          @change="loadServers(form.service_id)"
        >
          <option value="">Select once</option>
          <option
            v-for="(server, index) in services"
            :key="'server' + index"
            :value="server.id"
          >
            {{ server?.name }}
          </option>
        </select>
        <v-errors :errors="errorFor('service_id')"></v-errors>
      </div>
      <div class="mb-3">
        <label for="server" class="col-form-label">Server</label>
        <select
          class="form-select"
          id="server"
          v-model="form.server_id"
          @change="findSelectedServer"
        >
          <option value="">Select once</option>
          <option
            v-for="(server, index) in servers"
            :key="'server' + index"
            :value="server.id"
          >
            {{ server?.host_name }}
          </option>
        </select>
        <v-errors :errors="errorFor('server_id')"></v-errors>
      </div>

      <InputGroup
        label="Subject"
        type="text"
        v-model="form.subject"
        placeholder="Subject"
        :required="true"
        :validation-error="errorFor('subject')"
      />

      <div :class="['form_row', { has_error: errorFor('description') }]">
        <label for="message">Message</label>
        <div class="mb-3">
          <text-editor
            v-model:text="form.message"
            :id="'message'"
          ></text-editor>
          <v-errors :errors="errorFor('message')"></v-errors>
        </div>
      </div>

      <div class="author_comment">
        <div :class="['', {'has_error': errorFor('attachments')}]">
          <label for="attachments">Attach file</label>
          <div class="mb-3">
            <div class="custom_tab_content_inner" :class="[{'has_error': errorFor('attachments')}]">
              <div class="product_list_wrap">
                <div class="upload_btn dropzone-clickable mt_5 mb_10">
                  <button type="button" class="btn btn-secondary width_150p">Upload files</button>
                </div>
                <div class="product_list">
                  <draggable
                      :list="form.attachments"
                      item-key="image"
                      tag="ul"
                      ghost-class="ghost"
                      class="d-inline-flex"
                      @end="imageSorted"
                  >
                    <template #item="{ element, index }">
                      <li>
                        <div class="inner">
                          <div class="img pe-2 pb-2">
                            <template v-if="['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(element.file_extension)">
                              <div class="cross_ic cursor_pointer" @click="removeImage(element, index)"><i class="fas fa-times"></i>
                              </div>
                              <img :src="element.file_path" width="80px" class="img-thumbnail">
                            </template>
                            <template v-if="['pdf'].includes(element.file_extension)">
                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i>
                              </div>
                              <embed :src="element.file_path">
                            </template>
                            <template
                                v-if="['xls','xlsx','xlm','xla','xlc','xlt','xlw','csv'].includes(element.file_extension)">
                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i>
                              </div>
                              <i class="fas fa-file-excel fa-10x"></i>
                            </template>
                            <template v-if="['docx'].includes(element.file_extension)">
                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i>
                              </div>
                              <i class="fas fa-file-word fa-10x"></i>
                            </template>
                            <template v-if="['zip'].includes(element.file_extension)">
                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i>
                              </div>
                              <i class="fas fa-file-archive fa-10x"></i>
                            </template>
                            <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                                pgh
                                <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                            </template> -->
                          </div>
                        </div>
                      </li>
                    </template>
                  </draggable>
                </div>
                <div class="dropzone-previews"></div>
                <div class="dropzone_wrap bg-light">
                  <div class="create_images_drag dropzone-clickable dropzone-container">
                    <div class="images p-4 py-lg-5">
                      <span>Drag and drop images from your computer.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <v-errors :errors="errorFor('attachments')"></v-errors>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="d_flex_start">
          <button
            type="button"
            class="btn btn-primary btn-md width_100p"
            :disabled="lyLoading"
            @click="submit"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from "dropzone";
import InputGroup from '@/components/FormControl/InputGroupComponent.vue';
import TextEditor from '@/components/shared/TextEditor.vue';
import {mapGetters} from "vuex";
import Cookies from "js-cookie";
import draggable from 'vuedraggable'

export default {
  name: 'InquiryForm',
  components: { TextEditor, InputGroup, draggable },
  props: ['closeModal', 'loadData', 'editId'],
  data() {
    return {
      lyLoading: false,
      form: {
        service_id: '',
        server_id: '',
        attachments: [],
      },
      services: [],
      servers: [],
      serverRegions: [],
      selectedServer: null,
      selectedService: null,
      dropzoneInstance: null
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser'
    })
  },
  created() {
    this.loadServices();
  },
  mounted() {
    // Prevent drag-and-drop opening file in browser
    window.addEventListener("dragover", function(e) {
      e.preventDefault();
    }, false);

    window.addEventListener("drop", function(e) {
      e.preventDefault();
    }, false);

    this.$nextTick(() => {
      this.initializeDropzone();
    });
  },
  updated() {
    if (!this.dropzoneInstance) {
      this.$nextTick(() => {
        this.initializeDropzone();
      });
    }
  },
  methods: {
    initializeDropzone() {
      if (this.dropzoneInstance) {
        this.dropzoneInstance.destroy();
        this.dropzoneInstance = null;
      }
      let that = this;

      // for image.
      that.$nextTick(() => {
        that.dropzoneInstance = new Dropzone(".dropzone-container", {
          clickable: '.dropzone-clickable',
          disablePreviews: true, // will not show preview
          createImageThumbnails: true,
          addRemoveLinks: true,
          previewsContainer: '.dropzone-previews',
          maxFiles: 2000,
          maxFilesize: 5,
          acceptedFiles: '.gif,.png,.jpg,.jpeg,.JPG,.xls,.xlsx,.xlm,.xla,.xlc,.xlt,.xlw,.csv,.pdf,.docx,.zip',
          accept: function (file, done) {
            const allowedTypes = [
              '.gif', '.png', '.jpg', '.jpeg', '.JPG',
              '.xls', '.xlsx', '.xlm', '.xla', '.xlc', '.xlt', '.xlw',
              '.csv', '.pdf', '.docx', '.zip'
            ];

            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            const maxSizeMB = 5;

            if (!allowedTypes.includes(ext)) {
              // that.showFailMsg('Unsupported file type.');
              done("Unsupported file type.");
            } else if (file.size > maxSizeMB * 1024 * 1024) {
              // that.showFailMsg("File too large." + maxSizeMB);
              done("File too large.");
            } else {
              done(); // file is accepted
            }
          },
          headers: {
            'Authorization': `Bearer ${Cookies.get('auth_token')}`
          },
          url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
          success: function (file, response) {
            let image = {
              id: '',
              sort: that.form.attachments.length + 1,
              draft: response.draft,
              file_extension: response.file_extension,
              file_path: response.file_path,
              original_file_name: response.original_file_name,
              original_size: response.original_size,
            }
            that.form.attachments.push(image)
          },
          error: function (file, response) {
            that.showFailMsg(response);
            console.log(response,'error error')
            let errors = that.errors ? that.errors : {};
            errors.attachments = (errors && errors.attachments) ? errors.attachments : [];
            errors.attachments = response?.errors?.file
            that.errors = errors;
            // this.removeFile(file);
            if (file.accepted === false) {
              // alert("File type not supported: " + file.name);
              that.dropzoneInstance.removeFile(file); // optional: remove rejected file from queue
            }
          },
          removedfile: function () {
            let errors = that.errors ? that.errors : {};
            errors.attachments = null;
            that.errors = errors;
            // since no preview there is nothing to remove
            // file.previewElement.remove();
          }
        });
      })
    },
    removeImage(element, index) {
      if (!this.form) return;
      if (!this.form.attachments) return;
      if (!element.id) {
        let formData = new FormData()
        formData.append('draft', element.draft);
        this.axios.post('/temporary-image-remove', formData).then(() => {
        });
      }
      this.form.attachments.splice(index, 1)
      this.imageSorted();
    },
    imageSorted() {
      let sort = 1;
      for (let index = 0; index < this.form.attachments.length; index++) {
        this.form.attachments[index].sort = sort++;
      }
    },
    loadServices() {
      this.axios.get('/customer-cloud-services').then(({ data }) => {
        this.services = data.data;
      });
    },
    loadServers(serviceId) {
      this.axios
        .get(`/customer-cloud-servers/?service_id=${serviceId}`)
        .then(({ data }) => {
          this.servers = data.data;
          this.findSelectedService();
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData()
      this.form.ticket_id = this.inquiryId
      Object.keys(this.form).forEach(key => {
        if (key !== 'attachments') {
          formData.append(key, this.form[key] ? this.form[key] : '');
        }
      })

      formData.append('attachments', JSON.stringify(this.form.attachments))
      formData.append('service_name', this.selectedService?.name)
      formData.append('server_name', this.selectedServer?.host_name)

      this.axios
        .post('/my-inquiry', formData)
        .then(({ data }) => {
          if (data.success) {
            this.loadData();
            this.showSuccessMsg(data.message);
            this.closeModal();
          } else {
            this.showFailMsg(data.message);
          }
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    findSelectedService() {
      this.selectedService = this.services.find(
        (service) => service.id === this.form.service_id
      );
    },
    findSelectedServer() {
      this.selectedServer = this.servers.find(
        (server) => server.id === this.form.server_id
      );
    },
  },
};
</script>
<style scoped></style>
